import alergia from '@/router/cadastro/alergia'
import autorizador from '@/router/cadastro/autorizador'
import bairro from '@/router/cadastro/bairro'
import convenioMedico from '@/router/cadastro/convenioMedico'
import especialidade from './especialidade'
import ferida from './ferida'
import fabricante from '@/router/cadastro/fabricante'
import feriado from '@/router/cadastro/feriado'
import fornecedor from '@/router/cadastro/fornecedor'
import grupo from '@/router/cadastro/grupo'
import logradouro from '@/router/cadastro/logradouro'
import loteamento from '@/router/cadastro/loteamento'
import material from '@/router/cadastro/material'
import medicamento from '@/router/cadastro/medicamento'
import obito from '@/router/cadastro/obito'
import oci from '@/router/cadastro/oci'
import origemProgramatica from './origemProgramatica'
import paciente from '@/router/cadastro/paciente'
import parametrizacao from '@/router/cadastro/parametrizacao'
import relatorioMaterial from '@/router/cadastro/relatorioMaterial'
import relatorioPacienteBairro from '@/router/cadastro/relatorioPacienteBairro'
import relatorioPacienteConectaCidadao from '@/router/cadastro/relatorioPacienteConectaCidadao'
import relatorioUsuario from '@/router/cadastro/relatorioUsuario'
import sala from '@/router/cadastro/sala'
import servicoManutencao from '@/router/cadastro/servico-manutencao'
import setor from '@/router/cadastro/setor'
import subgrupo from '@/router/cadastro/subgrupo'
import supervisor from './supervisor'
import unidade from '@/router/cadastro/unidade'
import unidadeExecutanteManutencao from '@/router/cadastro/unidade-executante-manutencao'
import unidadeExterna from '@/router/cadastro/unidadeExterna'
import unificacaoUsuarioPaciente from '@/router/cadastro/unificacaoUsuarioPaciente'
import usuario from '@/router/cadastro/usuario'
import usuarioPerfil from '@/router/cadastro/usuarioPerfil'
import vacina from '@/router/cadastro/vacina'

export default [
    {
        path: 'cadastro',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...alergia,
            ...autorizador,
            ...bairro,
            ...convenioMedico,
            ...especialidade,
            ...ferida,
            ...fabricante,
            ...feriado,
            ...fornecedor,
            ...grupo,
            ...logradouro,
            ...loteamento,
            ...material,
            ...medicamento,
            ...obito,
            ...oci,
            ...origemProgramatica,
            ...paciente,
            ...parametrizacao,
            ...relatorioMaterial,
            ...relatorioPacienteBairro,
            ...relatorioPacienteConectaCidadao,
            ...relatorioUsuario,
            ...sala,
            ...servicoManutencao,
            ...setor,
            ...subgrupo,
            ...supervisor,
            ...unidade,
            ...unidadeExecutanteManutencao,
            ...unidadeExterna,
            ...unificacaoUsuarioPaciente,
            ...usuario,
            ...usuarioPerfil,
            ...vacina,
        ]
    }
]